// src/features/agent/pages/CouponView.tsx
// import Title from "antd/es/typography/Title";
import { CouponTable } from "features/agent/compoenents/table/coupontable";
import {
  CouponFilterFormValues,
  CouponFilterFormValuesPaginated,
  // UserAgentField,
} from "features/agent/compoenents/top-bar/Coupon-filter-form/types";
import { CouponTopBar } from "features/agent/compoenents/top-bar/coupon-top-bar";
import { useGetCouponList } from "features/agent/use-cases/get-coupon-list";
import { usePaginationParams } from "hooks";

export const CouponView = () => {

  const initialFilters: CouponFilterFormValues = {
    CouponId: undefined,
    CouponCode: undefined,
    CouponTitle: undefined,
    ActionByName: undefined,
  };

  const { params, updateParams, resetPage } =
    usePaginationParams<CouponFilterFormValuesPaginated>({
      page: 1,
      size: 10,
      ...initialFilters,
    });

  const handleFiltersChange = (values: CouponFilterFormValues) => {
    updateParams(values);
    resetPage(); // go back to page 1 on filter change
  };

//, {
  //   retry: false,
  // }
  
  const { data, isLoading } = useGetCouponList(params);


  return (
    <>
      {/* <Title level={3}>Coupons</Title> */}

      <CouponTopBar
        handleFilter={handleFiltersChange}
        getInitialFilterValues={initialFilters}
        adminUserEditData={undefined}
      />

      <CouponTable
        isCouponListLoading={isLoading}
        couponList={data?.items ?? []}
        itemsCount={data?.total ?? 0}
        tableParams={{
          page: params.page,
          size: params.size,
        }}
        updateParams={updateParams}
      />
    </>
  );
};
